/*
 * <hero-hotspots> — hotspot buttons on the hero image.
 * Desktop: tooltips are CSS-only (hover / focus-within). Mobile: tapping a hotspot activates it and shows
 * the matching card under the image ([data-hotspot-card]).
 */
if (!customElements.get('hero-hotspots')) {
  class HeroHotspots extends HTMLElement {
    connectedCallback() {
      this.buttons = [...this.querySelectorAll('[data-hotspot]')];
      this.cards = [...this.querySelectorAll('[data-hotspot-card]')];
      this.onClick = (event) => {
        const button = event.target.closest('[data-hotspot]');
        if (button && this.contains(button)) this.activate(button.dataset.hotspot);
      };
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    activate(index) {
      for (const button of this.buttons) {
        button.setAttribute('aria-pressed', String(button.dataset.hotspot === index));
      }
      for (const card of this.cards) {
        card.hidden = card.dataset.hotspotCard !== index;
      }
    }
  }
  customElements.define('hero-hotspots', HeroHotspots);
}
